import { Player } from "~/business";
import { XMeaple } from "./XMeaple";

export const XPlayerMeaples = ({
  player,
  meapleWidth,
  noAnimation = false,
}: {
  player: Player;
  meapleWidth: number;
  noAnimation?: boolean;
}) => {
  const { workerPile } = player;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
      {[...new Array(Math.max(3, workerPile.length))].map((_, index) => {
        const worker = workerPile.pile.at(index);
        return (
          <XMeaple
            key={worker?.id ?? index.toString()}
            meaple={worker}
            width={meapleWidth}
            noAnimation={noAnimation}
          />
        );
      })}
    </div>
  );
};
